/**
 * Customer Reviews 轮播：左右按钮滚动 + 鼠标拖拽
 */
(function () {
  const SECTION_SELECTOR = '.customer-reviews';
  const TRACK_SELECTOR = '[data-customer-reviews-track]';
  const PREV_SELECTOR = '[data-customer-reviews-prev]';
  const NEXT_SELECTOR = '[data-customer-reviews-next]';
  const REVIEW_BADGE_SELECTOR = '.jdgm-preview-badge';
  const OFFICIAL_REVIEWS_SELECTOR = '#judgeme_product_reviews';

  function initReviewBadgeLink(section) {
    const badge = document.querySelector(REVIEW_BADGE_SELECTOR);
    if (!badge || badge.dataset.neobayReviewLinkInitialized === 'true') return;

    badge.dataset.neobayReviewLinkInitialized = 'true';
    badge.classList.add('jdgm-preview-badge--with-link');
    badge.addEventListener('click', (event) => {
      const target = document.querySelector(OFFICIAL_REVIEWS_SELECTOR) || section;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initSection(section) {
    const track = section.querySelector(TRACK_SELECTOR);
    const prevBtn = section.querySelector(PREV_SELECTOR);
    const nextBtn = section.querySelector(NEXT_SELECTOR);
    initReviewBadgeLink(section);
    if (!track) return;

    const scrollStep = () => {
      const cardWidth = track.querySelector('.customer-reviews__card')?.offsetWidth ?? 320;
      const gap = parseInt(getComputedStyle(track).gap, 10) || 16;
      return cardWidth + gap;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
    }

    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      isDown = true;
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', () => {
      isDown = false;
      track.style.cursor = 'grab';
      track.style.scrollSnapType = '';
    });

    track.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      track.style.cursor = 'grab';
      track.style.scrollSnapType = 'x mandatory';
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.2;
      track.scrollLeft = scrollLeft - walk;
    });

    track.style.cursor = 'grab';
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
